import api from '../services/api';
/**
 * Gets the cluster configuration
 * @param idToken string
 * @param schema string
 * @returns axios response
 */
export const getClusterConfig = async (idToken: string, schema: string) => {
  return api.get('/schemas/cluster-info', {
    headers: { authorization: `Bearer ${idToken}`, 'Myosh-Schema': `${schema}` },
  });
};
